// extracted by mini-css-extract-plugin
module.exports = {"root":"PageTurner_root__OGgnf","mainIcon":"PageTurner_mainIcon__5Rv5D","stepIcon":"PageTurner_stepIcon__BxGJ4","row":"PageTurner_row__17eH2"};